// O TEMA DO DOCUMENTO — e por que ele deixou de ser uma escolha.
//
// Este arquivo já foi um seletor de tema com dois valores, persistência em `localStorage` e um
// painel em Configurações. O operador corrigiu o entendimento, na letra:
//
//   "não tem modo escuro, tem o modo atual e o modo clássico que é o modo original nas mesmas
//    cores e estruturas (...) a ideia é que isso seja feito com ROTAS APARTADAS"
//
// Tema global e rota apartada são coisas incompatíveis, e manter os dois produzia o pior dos
// dois: com o tema "clássico" escolhido, a rota MODERNA aparecia pintada de clássico, e a rota
// `/classico` — que existe justamente para preservar o original — ficava indistinguível do resto.
//
// Então a plataforma tem um tema só, o da marca, e a versão clássica é um ENDEREÇO: `/classico`
// carrega `data-tema="classico"` numa `<div>` própria, e a variável CSS herda só ali dentro.
//
// ── A MIGRAÇÃO, QUE É A PARTE FÁCIL DE ESQUECER ───────────────────────────────────────────────
//
// Quem já usou a plataforma e escolheu "clássico" tem `hq-lab:tema=classico` guardado no
// navegador. Se este arquivo apenas parasse de LER a chave, o atributo antigo continuaria... não:
// o atributo era escrito a cada carga, então some sozinho. O problema é outro e é pior — a chave
// fica órfã, e um dia alguém reintroduz a leitura e ressuscita uma preferência de anos atrás.
// Por isso ela é APAGADA, uma vez, na montagem.

import { useEffect } from "react";
import "./tokens.scss";

/** A chave que o seletor de tema usava. Existe aqui só para ser removida. */
const CHAVE_ANTIGA = "hq-lab:tema";

export function ProvedorDeTema({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Explícito, e não implícito pelo `:root` sem atributo: um atributo escrito é uma afirmação
    // que dá para inspecionar no navegador, e o CSS tem um seletor de tema só para casar.
    document.documentElement.setAttribute("data-tema", "quadrinho");

    try {
      window.localStorage.removeItem(CHAVE_ANTIGA);
    } catch {
      // `localStorage` lança em navegação privada com cookies bloqueados. Não conseguir limpar
      // uma chave morta não é motivo para quebrar a página.
    }
  }, []);

  return <>{children}</>;
}
